import { Component, OnInit, Input } from "@angular/core";
import { ReportDropDownList } from "../../../../models/report-preview/report-dropdown-list";
import { FromToDetail } from "../../../../../_objects/report-element";
import { Notifier, OfflineReportPreviewService, MousePoint } from "../../../../../_services/offline-report-preview.service";

@Component({
  selector: "app-report-dropdown-list",
  templateUrl: "./report-dropdown-list.component.html",
  styleUrls: ["./report-dropdown-list.component.scss"],
  standalone: false
})
export class ReportDropDownListOfflineComponent implements OnInit {
  @Input() pageKey: string;
  @Input() dropDownListKey: string;
  @Input() public elementLocation: string;

  public reportDropDownList: ReportDropDownList;
  private notifier: Notifier;
  readonly dropdownListStyle = "position: absolute;";

  constructor(public designService: OfflineReportPreviewService) {}

  ngOnInit() {
    this.notifier = {
      componentName: "report-dropdown-list.component",
      ids: { pageId: this.pageKey, elementId: this.dropDownListKey }
    };
    this.reportDropDownList = this.designService.getDropDownList(this.dropDownListKey);
    // let elementNavigator = this.designService.navigatorElements
    // .filter((x) => x.pageKey == this.pageKey)[0]
    // .elementsDetails.filter((y) => y.location == this.elementLocation)[0]
    //   .elements;

    //  elementNavigator.filter(x=>x.elementName == ElementType.DropDownList).length > 0
    //   ? elementNavigator.filter(x=>x.elementName == ElementType.DropDownList)[0].elementData.push({
    //       id: this.dropDownListKey,
    //       page: this.pageKey,
    //       name: this.reportDropDownList.getTitle(),
    //     })
    //   : elementNavigator.push({
    //       elementName: ElementType.DropDownList,
    //       isVisible: false,
    //       elementData: [
    //         {
    //           id: this.dropDownListKey,
    //           page: this.pageKey,
    //           name: this.reportDropDownList.getTitle(),
    //         },
    //       ],
    //     });
  }

  onClick(event: MouseEvent) {
    if (this.reportDropDownList.isSelectable) {
      event.stopPropagation();
    }
  }

  onDragStart(event: DragEvent) {
    event.dataTransfer.setData("text", this.dropDownListKey);
    event.dataTransfer.effectAllowed = "move";

    const fromDetail: FromToDetail = {
      location: this.reportDropDownList.getLocation(),
      pageId: this.pageKey
    };
    const dragPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    const template = { ...this.designService.originTemplate };
    template.reportTemplateContent = JSON.stringify(this.designService.getTemplate());
    const dragElemId = event.dataTransfer.getData("text");

    const toDetail: FromToDetail = {
      location: this.reportDropDownList.getLocation(),
      pageId: this.pageKey
    };
    const dropPoint: MousePoint = {
      onElementX: this.reportDropDownList.getLeftPx() + event.offsetX,
      onElementY: this.reportDropDownList.getTopPx() + event.offsetY
    };

    event.dataTransfer.clearData("text");
    event.stopPropagation();
  }
}
